import React from 'react'
import './style.min.css'

const PageHeading = ({
  number, text
}) => (
  <>
    <h2 className="PageHeading xlarge padding-48">
      {number && <span className="opacity-max" style={{ marginRight: '20px' }}
      >{number}</span>}
      {text}
    </h2>
  </>
)

export default PageHeading